__turbopack_context__.v({
  "app_sign_in_success": "AppSignInSuccess-module-scss-module__wNob3G__app_sign_in_success",
  "app_sign_in_success_content_bottom": "AppSignInSuccess-module-scss-module__wNob3G__app_sign_in_success_content_bottom",
  "app_sign_in_success_content_top": "AppSignInSuccess-module-scss-module__wNob3G__app_sign_in_success_content_top",
  "app_sign_in_success_passport_learn_more": "AppSignInSuccess-module-scss-module__wNob3G__app_sign_in_success_passport_learn_more",
  "app_sign_in_success_passport_lockup": "AppSignInSuccess-module-scss-module__wNob3G__app_sign_in_success_passport_lockup",
});
